import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import { Invoice, InvoicesTypes } from './types.ts'

const getInvoices = async () => {
  let fetchResponse = {
    data: [] as InvoicesTypes[],
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get('/api/invoice/')
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const getInvoice = async (invoiceId: number) => {
  let fetchResponse = {
    data: {} as Invoice,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get(`/api/invoice/${invoiceId}/`)
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const getInvoicesSummary = async (fromDate: string, toDate: string) => {
  let fetchResponse = {
    data: [] as Invoice[],
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get(`/api/invoice/summary/?from_date=${fromDate}&to_date=${toDate}`)
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

export const invoiceAPI = {
  getInvoices,
  getInvoice,
  getInvoicesSummary,
}
